var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.isEdit ||
      _vm.sendStatus == null ||
      (_vm.sendStatus >= 0 && _vm.sendStatus <= 60)
        ? _c(
            "div",
            { staticClass: "form-section" },
            [
              _c("div", { staticClass: "section-title" }, [_vm._v("发起信息")]),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发货单据号" } },
                            [
                              _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.deliveryNo || "-")),
                              ]),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("el-form-item", { attrs: { label: "发起人" } }, [
                            _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.initiator || "-")),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEdit
                    ? _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c("el-form-item", { attrs: { label: "发起时间" } }, [
                            _c("span", { staticClass: "readonly-text" }, [
                              _vm._v(_vm._s(_vm.initiateTime || "-")),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "deliveryType",
                            label: "发货方式",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.deliveryType || "-")),
                              ])
                            : _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择发货方式" },
                                  model: {
                                    value: _vm.form.deliveryType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deliveryType", $$v)
                                    },
                                    expression: "form.deliveryType",
                                  },
                                },
                                [
                                  _vm.$parent.checkPer([
                                    "admin",
                                    "delivery:delivery",
                                  ])
                                    ? _c("el-option", {
                                        attrs: {
                                          label: "配送(到家)",
                                          value: "配送(到家)",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer([
                                    "admin",
                                    "delivery:delivery",
                                  ])
                                    ? _c("el-option", {
                                        attrs: {
                                          label: "配送(到物流点)",
                                          value: "配送(到物流点)",
                                        },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer([
                                    "admin",
                                    "delivery:otherSend",
                                  ])
                                    ? _c("el-option", {
                                        attrs: { label: "自提", value: "自提" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer([
                                    "admin",
                                    "delivery:otherSend",
                                  ])
                                    ? _c("el-option", {
                                        attrs: { label: "物流", value: "物流" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer([
                                    "admin",
                                    "delivery:otherSend",
                                  ])
                                    ? _c("el-option", {
                                        attrs: { label: "快递", value: "快递" },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.$parent.checkPer([
                                    "admin",
                                    "delivery:otherSend",
                                  ])
                                    ? _c("el-option", {
                                        attrs: { label: "闪送", value: "闪送" },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "hasLargeFurniture",
                          },
                        },
                        [
                          _c("template", { slot: "label" }, [_vm._v("大家居")]),
                          _vm._v(" "),
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(
                                  _vm._s(_vm.form.hasLargeFurniture || "-")
                                ),
                              ])
                            : _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "下拉选择" },
                                  model: {
                                    value: _vm.form.hasLargeFurniture,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "hasLargeFurniture",
                                        $$v
                                      )
                                    },
                                    expression: "form.hasLargeFurniture",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "需要安装",
                                      value: "需要安装",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "无需安装",
                                      value: "无需安装",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "sendDate",
                            label: "上门日期",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.sendDate || "-")),
                              ])
                            : _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd",
                                  "picker-options": _vm.pickerOptions,
                                },
                                on: { change: _vm.handleSendDateChange },
                                model: {
                                  value: _vm.form.sendDate,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "sendDate", $$v)
                                  },
                                  expression: "form.sendDate",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "doorTime",
                            label: "上门时间",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.form.doorTime || []).join(" - ") || "-"
                                  )
                                ),
                              ])
                            : _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("el-time-select", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      placeholder: "开始时间",
                                      "picker-options":
                                        _vm.startTimePickerOptions,
                                    },
                                    on: { change: _vm.handleDoorTimeChange },
                                    model: {
                                      value: _vm.form.doorTime[0],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form.doorTime, 0, $$v)
                                      },
                                      expression: "form.doorTime[0]",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticStyle: { margin: "0 4px" } },
                                    [_vm._v("-")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-time-select", {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      placeholder: "结束时间",
                                      "picker-options": {
                                        start: "00:00",
                                        step: "01:00",
                                        end: "24:00",
                                        minTime: _vm.form.doorTime[0],
                                      },
                                    },
                                    model: {
                                      value: _vm.form.doorTime[1],
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form.doorTime, 1, $$v)
                                      },
                                      expression: "form.doorTime[1]",
                                    },
                                  }),
                                ],
                                1
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "enterType",
                            label: "进门方式",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.enterType || "-")),
                              ])
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { placeholder: "下拉选择" },
                                  model: {
                                    value: _vm.form.enterType,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "enterType", $$v)
                                    },
                                    expression: "form.enterType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "钥匙", value: "钥匙" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "密码", value: "密码" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "远程", value: "远程" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "现场有人",
                                      value: "现场有人",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "其它", value: "其它" },
                                  }),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "receivePerson",
                            label: "收货人",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.receivePerson || "-")),
                              ])
                            : _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.receivePerson,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "receivePerson", $$v)
                                  },
                                  expression: "form.receivePerson",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "receivePhone",
                            label: "收货电话",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.receivePhone || "-")),
                              ])
                            : _c("el-input", {
                                attrs: { placeholder: "请输入" },
                                model: {
                                  value: _vm.form.receivePhone,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "receivePhone", $$v)
                                  },
                                  expression: "form.receivePhone",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "receiveAddress",
                            label: "收货地址",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.form.receiveAddress || "-")),
                              ])
                            : _c("AddressCascader", {
                                on: {
                                  "coordinate-change":
                                    _vm.handleAddressCoordinateChange,
                                },
                                model: {
                                  value: _vm.form.receiveAddress,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "receiveAddress", $$v)
                                  },
                                  expression: "form.receiveAddress",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: _vm.isEdit ? "" : "coordinate",
                            label: "收货坐标",
                          },
                        },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.coordinate || "-")),
                              ])
                            : _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请选择定位" },
                                  on: { focus: _vm.openMapSelector },
                                  model: {
                                    value: _vm.form.coordinate,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "coordinate", $$v)
                                    },
                                    expression: "form.coordinate",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-location el-input__icon",
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#409EFF",
                                    },
                                    attrs: { slot: "suffix" },
                                    on: { click: _vm.openMapSelector },
                                    slot: "suffix",
                                  }),
                                ]
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "备注" } },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.enterRemark || "-")),
                              ])
                            : _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  placeholder: "请输入，限100个字符。",
                                  maxlength: "100",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.enterRemark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "enterRemark", $$v)
                                  },
                                  expression: "form.enterRemark",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "派单备注" } },
                        [
                          _vm.isEdit
                            ? _c("span", { staticClass: "readonly-text" }, [
                                _vm._v(_vm._s(_vm.form.remark || "-")),
                              ])
                            : _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  placeholder: "请输入，限200个字符。",
                                  maxlength: "200",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark",
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "附件" } },
                        [
                          _vm.isEdit
                            ? [
                                _vm.previewAttachmentList.length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "attachment-name-list" },
                                      [
                                        _vm._l(
                                          _vm.previewAttachmentList,
                                          function (item, idx) {
                                            return [
                                              item.isImage
                                                ? _c("el-image", {
                                                    key: "img" + idx,
                                                    staticStyle: {
                                                      width: "50px",
                                                      height: "50px",
                                                      "border-radius": "4px",
                                                    },
                                                    attrs: {
                                                      src: item.url,
                                                      "preview-src-list":
                                                        _vm.previewAttachmentList
                                                          .filter(function (i) {
                                                            return i.isImage
                                                          })
                                                          .map(function (i) {
                                                            return i.url
                                                          }),
                                                      fit: "cover",
                                                    },
                                                  })
                                                : _c(
                                                    "span",
                                                    {
                                                      key: "file" + idx,
                                                      staticClass:
                                                        "attachment-name-item",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.downloadAttachment(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  ),
                                            ]
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  : _c("span", [_vm._v("-")]),
                              ]
                            : _c("CommonUpload", {
                                ref: "deliveryAttachment",
                                on: {
                                  uploadSuccess: _vm.handleAttachmentUpload,
                                  delSuccess: _vm.handleAttachmentDel,
                                },
                              }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop:
                              _vm.isEdit && _vm.sendStatus !== 1
                                ? ""
                                : "deliveryVehicle",
                            label: "送货车辆",
                          },
                        },
                        [
                          _vm.isEdit && _vm.sendStatus !== 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (_vm.form.deliveryVehicle || []).join(
                                      ", "
                                    ) || "-"
                                  )
                                ),
                              ])
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "从车辆库选择",
                                    filterable: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                  },
                                  model: {
                                    value: _vm.form.deliveryVehicle,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deliveryVehicle", $$v)
                                    },
                                    expression: "form.deliveryVehicle",
                                  },
                                },
                                _vm._l(_vm.allVehicleList, function (v) {
                                  return _c("el-option", {
                                    key: v.id || v.licensePlate,
                                    attrs: {
                                      label:
                                        v.licensePlate + " " + (v.brand || ""),
                                      value: v.licensePlate,
                                    },
                                  })
                                }),
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop:
                              _vm.isEdit && _vm.sendStatus !== 1
                                ? ""
                                : "deliveryDriver",
                            label: "送货司机",
                          },
                        },
                        [
                          _vm.isEdit && _vm.sendStatus !== 1
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.driverDisplayNames)),
                              ])
                            : _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "输入姓名或手机号搜索司机",
                                    filterable: "",
                                    remote: "",
                                    multiple: "",
                                    "collapse-tags": "",
                                    "remote-method": _vm.searchDriver,
                                    loading: _vm.driverSearchLoading,
                                  },
                                  model: {
                                    value: _vm.form.deliveryDriver,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "deliveryDriver", $$v)
                                    },
                                    expression: "form.deliveryDriver",
                                  },
                                },
                                _vm._l(_vm.driverList, function (d) {
                                  return _c(
                                    "el-option",
                                    {
                                      key: d.id,
                                      attrs: {
                                        label: d.realName + " " + d.phone,
                                        value: d.userId,
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(d.realName) +
                                            " " +
                                            _vm._s(d.phone)
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.vehicleList.length > 0 && (!_vm.isEdit || _vm.sendStatus === 1)
        ? _c(
            "div",
            { staticClass: "form-section" },
            [
              _c(
                "div",
                { staticClass: "section-title" },
                [
                  _c("span", [_vm._v("司机状态")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "section-refresh",
                      attrs: { type: "text", icon: "el-icon-refresh" },
                      on: { click: _vm.loadVehicleList },
                    },
                    [_vm._v("刷新")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.vehicleList,
                    border: "",
                    "row-class-name": _vm.orderRowClassName,
                  },
                  on: { "row-click": _vm.handleVehicleRowClick },
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "driver", label: "司机信息", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "driver-info" }, [
                                _c("div", { staticClass: "driver-name" }, [
                                  _vm._v(_vm._s(scope.row.driverName)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "driver-phone" }, [
                                  _vm._v(_vm._s(scope.row.driverPhone)),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      365780359
                    ),
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.dateList, function (date, index) {
                    return _c(
                      "el-table-column",
                      { key: index, attrs: { align: "center" } },
                      [
                        _c("template", { slot: "header" }, [
                          _c("div", { staticClass: "date-header" }, [
                            _vm._v(_vm._s(_vm.formatDate(date, "MM-DD"))),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "date-sub" }, [
                            _vm._v(_vm._s(_vm.formatDate(date, "EEE"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-table-column", {
                          key: index + "-am",
                          attrs: {
                            label: "上午",
                            align: "center",
                            width: "90",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "schedule-cell",
                                        class: _vm.getScheduleCellClassByPeriod(
                                          scope.row,
                                          date,
                                          "am"
                                        ),
                                      },
                                      [
                                        scope.row.status === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "schedule-busy",
                                                staticStyle: {
                                                  color: "#F56C6C",
                                                },
                                              },
                                              [_vm._v("维修")]
                                            )
                                          : scope.row.status === 3
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "schedule-busy",
                                                staticStyle: {
                                                  color: "#909399",
                                                },
                                              },
                                              [_vm._v("休息")]
                                            )
                                          : !_vm.hasScheduleData(
                                              scope.row,
                                              date,
                                              "am"
                                            )
                                          ? _c(
                                              "span",
                                              { staticClass: "schedule-free" },
                                              [_vm._v("空闲")]
                                            )
                                          : [
                                              _vm.getSendTimeList(
                                                scope.row,
                                                date,
                                                "am"
                                              ).length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "send-time-list",
                                                    },
                                                    _vm._l(
                                                      _vm.getSendTimeList(
                                                        scope.row,
                                                        date,
                                                        "am"
                                                      ),
                                                      function (st, sIdx) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key: sIdx,
                                                            staticClass:
                                                              "send-time-item",
                                                          },
                                                          [_vm._v(_vm._s(st))]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm.getTaskTimeList(
                                                    scope.row,
                                                    date,
                                                    "am"
                                                  ).length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "send-time-list",
                                                    },
                                                    _vm._l(
                                                      _vm.getTaskTimeList(
                                                        scope.row,
                                                        date,
                                                        "am"
                                                      ),
                                                      function (st, sIdx) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key: sIdx,
                                                            staticClass:
                                                              "send-time-item",
                                                          },
                                                          [_vm._v(_vm._s(st))]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "schedule-order",
                                                    },
                                                    [_vm._v("可用")]
                                                  ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          key: index + "-pm",
                          attrs: {
                            label: "下午",
                            align: "center",
                            width: "90",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "schedule-cell",
                                        class: _vm.getScheduleCellClassByPeriod(
                                          scope.row,
                                          date,
                                          "pm"
                                        ),
                                      },
                                      [
                                        scope.row.status === 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "schedule-busy",
                                                staticStyle: {
                                                  color: "#F56C6C",
                                                },
                                              },
                                              [_vm._v("维修")]
                                            )
                                          : scope.row.status === 3
                                          ? _c(
                                              "span",
                                              {
                                                staticClass: "schedule-busy",
                                                staticStyle: {
                                                  color: "#909399",
                                                },
                                              },
                                              [_vm._v("休息")]
                                            )
                                          : !_vm.hasScheduleData(
                                              scope.row,
                                              date,
                                              "pm"
                                            )
                                          ? _c(
                                              "span",
                                              { staticClass: "schedule-free" },
                                              [_vm._v("空闲")]
                                            )
                                          : [
                                              _vm.getSendTimeList(
                                                scope.row,
                                                date,
                                                "pm"
                                              ).length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "send-time-list",
                                                    },
                                                    _vm._l(
                                                      _vm.getSendTimeList(
                                                        scope.row,
                                                        date,
                                                        "pm"
                                                      ),
                                                      function (st, sIdx) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key: sIdx,
                                                            staticClass:
                                                              "send-time-item",
                                                          },
                                                          [_vm._v(_vm._s(st))]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm.getTaskTimeList(
                                                    scope.row,
                                                    date,
                                                    "pm"
                                                  ).length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "send-time-list",
                                                    },
                                                    _vm._l(
                                                      _vm.getTaskTimeList(
                                                        scope.row,
                                                        date,
                                                        "pm"
                                                      ),
                                                      function (st, sIdx) {
                                                        return _c(
                                                          "span",
                                                          {
                                                            key: sIdx,
                                                            staticClass:
                                                              "send-time-item",
                                                          },
                                                          [_vm._v(_vm._s(st))]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "schedule-order",
                                                    },
                                                    [_vm._v("可用")]
                                                  ),
                                            ],
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择位置",
            visible: _vm.mapDialogVisible,
            width: "60vw",
            top: "10vh",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.mapDialogVisible = $event
            },
            closed: _vm.handleMapClose,
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                height: "60vh",
                display: "flex",
                "flex-direction": "column",
              },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "margin-bottom": "10px",
                    position: "relative",
                    width: "70%",
                    "flex-shrink": "0",
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "请输入地址关键词搜索" },
                      on: { input: _vm.handleSearchInput },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function ($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword",
                      },
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.searchLocation },
                        slot: "append",
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showSearchResults && _vm.searchResults.length > 0
                    ? _c(
                        "div",
                        { staticClass: "search-results" },
                        _vm._l(_vm.searchResults, function (result, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "search-result-item",
                              on: {
                                click: function ($event) {
                                  return _vm.selectSearchResult(result)
                                },
                              },
                            },
                            [
                              _c("i", { staticClass: "el-icon-location" }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(result.name) +
                                    _vm._s(
                                      result.address ? " " + result.address : ""
                                    )
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticStyle: { width: "100%", flex: "1" },
                attrs: { id: "mapContainerPeisong" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.mapDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmMapSelection },
                },
                [_vm._v("确认选择")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isEdit
        ? _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("save", 1)
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("save", 10)
                    },
                  },
                },
                [_vm._v("提交")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("save", -1)
                    },
                  },
                },
                [_vm._v("暂存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isEdit && _vm.logData
        ? _c("div", { staticClass: "delivery-log" }, [
            _vm.logData.reservePerson ||
            _vm.logData.reserveTime ||
            _vm.sendStatus === 10 ||
            (_vm.logData.exceptionList && _vm.logData.exceptionList.length)
              ? _c(
                  "div",
                  { staticClass: "log-section" },
                  [
                    _c("div", { staticClass: "log-section-title" }, [
                      _vm._v("预约信息"),
                    ]),
                    _vm._v(" "),
                    !_vm.logData.reserveTime
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "log-item" }, [
                                _c("span", { staticClass: "log-label" }, [
                                  _vm._v("预约倒计时："),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "countdown-text",
                                    staticStyle: { color: "#F56C6C" },
                                  },
                                  [_vm._v(_vm._s(_vm.reserveCountdownText))]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.logData.reserveTime
                      ? _c(
                          "el-row",
                          {
                            staticStyle: {
                              display: "flex",
                              "flex-wrap": "wrap",
                            },
                            attrs: { gutter: 20 },
                          },
                          [
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  flex: "0 0 20%",
                                  "max-width": "20%",
                                },
                                attrs: { span: 24 },
                              },
                              [
                                _c("div", { staticClass: "log-item" }, [
                                  _c("span", { staticClass: "log-label" }, [
                                    _vm._v("预约人："),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.logData.reservePerson || "-")
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.logData.reservePhoto &&
                            _vm.logData.reservePhoto.length > 0
                              ? _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      flex: "0 0 20%",
                                      "max-width": "20%",
                                    },
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "log-item",
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "flex-start",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "log-label",
                                            staticStyle: {
                                              "white-space": "nowrap",
                                            },
                                          },
                                          [_vm._v("预约图片：")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "flex-wrap": "wrap",
                                              gap: "4px",
                                              "margin-left": "4px",
                                            },
                                          },
                                          _vm._l(
                                            _vm.logData.reservePhoto,
                                            function (img, idx) {
                                              return _c("el-image", {
                                                key: idx,
                                                staticStyle: {
                                                  width: "50px",
                                                  height: "50px",
                                                  "border-radius": "4px",
                                                },
                                                attrs: {
                                                  src: img.url,
                                                  "preview-src-list":
                                                    _vm.logData.reservePhoto.map(
                                                      function (i) {
                                                        return i.url
                                                      }
                                                    ),
                                                  fit: "cover",
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.logData.reserveRemark
                              ? _c(
                                  "el-col",
                                  {
                                    staticStyle: {
                                      flex: "0 0 20%",
                                      "max-width": "20%",
                                    },
                                    attrs: { span: 24 },
                                  },
                                  [
                                    _c("div", { staticClass: "log-item" }, [
                                      _c("span", { staticClass: "log-label" }, [
                                        _vm._v("预约备注："),
                                      ]),
                                      _vm._v(_vm._s(_vm.logData.reserveRemark)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  flex: "0 0 20%",
                                  "max-width": "20%",
                                },
                                attrs: { span: 24 },
                              },
                              [
                                _c("div", { staticClass: "log-item" }, [
                                  _c("span", { staticClass: "log-label" }, [
                                    _vm._v("预约时间："),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.logData.reserveTime || "-")
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-col",
                              {
                                staticStyle: {
                                  flex: "0 0 20%",
                                  "max-width": "20%",
                                },
                                attrs: { span: 24 },
                              },
                              [
                                _c("div", { staticClass: "log-item" }, [
                                  _c("span", { staticClass: "log-label" }, [
                                    _vm._v("预约及时性："),
                                  ]),
                                  _vm._v(
                                    _vm._s(_vm.logData.reserveTimeliness || "-")
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.logData.exceptionList &&
                    _vm.logData.exceptionList.length
                      ? [
                          _vm.logData.reserveTime || _vm.sendStatus === 10
                            ? _c("el-divider")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(
                            _vm.logData.exceptionList,
                            function (ex, exIdx) {
                              return _c(
                                "div",
                                { key: exIdx },
                                [
                                  exIdx > 0 ? _c("el-divider") : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-wrap": "wrap",
                                      },
                                      attrs: { gutter: 20 },
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            flex: "0 0 20%",
                                            "max-width": "20%",
                                          },
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "log-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "log-label" },
                                                [_vm._v("预约人：")]
                                              ),
                                              _vm._v(_vm._s(ex.person || "-")),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      ex.photo && ex.photo.length
                                        ? _c(
                                            "el-col",
                                            {
                                              staticStyle: {
                                                flex: "0 0 20%",
                                                "max-width": "20%",
                                              },
                                              attrs: { span: 24 },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "log-item",
                                                  staticStyle: {
                                                    display: "flex",
                                                    "align-items": "flex-start",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "log-label",
                                                      staticStyle: {
                                                        "white-space": "nowrap",
                                                      },
                                                    },
                                                    [_vm._v("预约异常图片：")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "flex-wrap": "wrap",
                                                        gap: "4px",
                                                        "margin-left": "4px",
                                                      },
                                                    },
                                                    _vm._l(
                                                      ex.photo,
                                                      function (img, idx) {
                                                        return _c("el-image", {
                                                          key: idx,
                                                          staticStyle: {
                                                            width: "50px",
                                                            height: "50px",
                                                            "border-radius":
                                                              "4px",
                                                          },
                                                          attrs: {
                                                            src: img.url,
                                                            "preview-src-list":
                                                              ex.photo.map(
                                                                function (i) {
                                                                  return i.url
                                                                }
                                                              ),
                                                            fit: "cover",
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            flex: "0 0 20%",
                                            "max-width": "20%",
                                          },
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "log-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "log-label" },
                                                [_vm._v("预约异常原因：")]
                                              ),
                                              _vm._v(_vm._s(ex.remark || "-")),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            flex: "0 0 20%",
                                            "max-width": "20%",
                                          },
                                          attrs: { span: 24 },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "log-item" },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "log-label" },
                                                [_vm._v("预约异常时间：")]
                                              ),
                                              _vm._v(_vm._s(ex.time || "-")),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.logData.loadingPerson ||
            _vm.logData.departureTime ||
            _vm.sendStatus === 20
              ? _c(
                  "div",
                  { staticClass: "log-section" },
                  [
                    _c("div", { staticClass: "log-section-title" }, [
                      _vm._v("出发信息"),
                    ]),
                    _vm._v(" "),
                    _vm.sendStatus === 20 && !_vm.logData.departureTime
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 24 } }, [
                              _c("div", { staticClass: "log-item" }, [
                                _c("span", { staticClass: "log-label" }, [
                                  _vm._v("上门倒计时："),
                                ]),
                                _c(
                                  "span",
                                  {
                                    staticClass: "countdown-text",
                                    style: {
                                      color:
                                        _vm.departCountdownText === "已超时"
                                          ? "#F56C6C"
                                          : "#409EFF",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.departCountdownText))]
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.logData.departureTime
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "log-item" }, [
                                _c("span", { staticClass: "log-label" }, [
                                  _vm._v("装车人："),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.logData.loadingPerson || "-")
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "log-item" }, [
                                _c("span", { staticClass: "log-label" }, [
                                  _vm._v("出发时间："),
                                ]),
                                _vm._v(
                                  _vm._s(_vm.logData.departureTime || "-")
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                {
                                  staticClass: "log-item",
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "log-label",
                                      staticStyle: { "white-space": "nowrap" },
                                    },
                                    [_vm._v("装车完成图：")]
                                  ),
                                  _vm._v(" "),
                                  _vm.logData.loadingPhoto &&
                                  _vm.logData.loadingPhoto.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-wrap": "wrap",
                                            gap: "4px",
                                            "margin-left": "4px",
                                          },
                                        },
                                        _vm._l(
                                          _vm.logData.loadingPhoto,
                                          function (img, idx) {
                                            return _c("el-image", {
                                              key: idx,
                                              staticStyle: {
                                                width: "50px",
                                                height: "50px",
                                                "border-radius": "4px",
                                              },
                                              attrs: {
                                                src: img.url,
                                                "preview-src-list":
                                                  _vm.logData.loadingPhoto.map(
                                                    function (i) {
                                                      return i.url
                                                    }
                                                  ),
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: { "margin-left": "4px" },
                                        },
                                        [_vm._v("-")]
                                      ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.logData.checkInPerson || _vm.logData.checkInTime
              ? _c(
                  "div",
                  { staticClass: "log-section" },
                  [
                    _c("div", { staticClass: "log-section-title" }, [
                      _vm._v("到达信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("签到人："),
                            ]),
                            _vm._v(_vm._s(_vm.logData.checkInPerson || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("签到时间："),
                            ]),
                            _vm._v(_vm._s(_vm.logData.checkInTime || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("到达及时性："),
                            ]),
                            _vm._v(
                              _vm._s(_vm.logData.arrivalTimeliness || "-")
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.logData.checkInAnomaly
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                { staticClass: "log-item" },
                                [
                                  _c("span", { staticClass: "log-label" }, [
                                    _vm._v("签到状态："),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "danger", size: "small" },
                                    },
                                    [_vm._v("打卡异常")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c("div", { staticClass: "log-item" }, [
                                _c("span", { staticClass: "log-label" }, [
                                  _vm._v("异常原因："),
                                ]),
                                _vm._v(
                                  _vm._s(
                                    _vm.logData.checkInAnomalyRemark || "-"
                                  ) + "\n          "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("el-col", { attrs: { span: 8 } }, [
                              _c(
                                "div",
                                { staticClass: "log-item" },
                                [
                                  _vm.logData.checkInAnomalyPhoto &&
                                  _vm.logData.checkInAnomalyPhoto.length > 0
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "log-label" },
                                          [_vm._v("异常图片：")]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.logData.checkInAnomalyPhoto,
                                          function (img, idx) {
                                            return _c("el-image", {
                                              key: idx,
                                              staticStyle: {
                                                width: "50px",
                                                height: "50px",
                                                "border-radius": "4px",
                                                "vertical-align": "middle",
                                              },
                                              attrs: {
                                                src: img.url,
                                                "preview-src-list":
                                                  _vm.logData.checkInAnomalyPhoto.map(
                                                    function (i) {
                                                      return i.url
                                                    }
                                                  ),
                                                fit: "cover",
                                              },
                                            })
                                          }
                                        ),
                                      ]
                                    : _c("span", [_vm._v("-")]),
                                ],
                                2
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.logData.deliverPerson || _vm.logData.deliverTime
              ? _c(
                  "div",
                  { staticClass: "log-section" },
                  [
                    _c("div", { staticClass: "log-section-title" }, [
                      _vm._v("送达信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("送达人："),
                            ]),
                            _vm._v(_vm._s(_vm.logData.deliverPerson || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("送达时间："),
                            ]),
                            _vm._v(_vm._s(_vm.logData.deliverTime || "-")),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 4 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("送达件数："),
                            ]),
                            _vm._v(
                              _vm._s(
                                _vm.logData.deliverPackageCount != null
                                  ? _vm.logData.deliverPackageCount
                                  : "-"
                              )
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-item",
                              staticStyle: {
                                display: "flex",
                                "align-items": "flex-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "log-label",
                                  staticStyle: { "white-space": "nowrap" },
                                },
                                [_vm._v("现场检查图：")]
                              ),
                              _vm._v(" "),
                              _vm.logData.siteCheckPhoto &&
                              _vm.logData.siteCheckPhoto.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-wrap": "wrap",
                                        gap: "4px",
                                        "margin-left": "4px",
                                      },
                                    },
                                    _vm._l(
                                      _vm.logData.siteCheckPhoto,
                                      function (img, idx) {
                                        return _c("el-image", {
                                          key: idx,
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            src: img.url,
                                            "preview-src-list":
                                              _vm.logData.siteCheckPhoto.map(
                                                function (i) {
                                                  return i.url
                                                }
                                              ),
                                            fit: "cover",
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "margin-left": "4px" } },
                                    [_vm._v("-")]
                                  ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-item",
                              staticStyle: {
                                display: "flex",
                                "align-items": "flex-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "log-label",
                                  staticStyle: { "white-space": "nowrap" },
                                },
                                [_vm._v("送货完成图：")]
                              ),
                              _vm._v(" "),
                              _vm.logData.deliveryCompletePhoto &&
                              _vm.logData.deliveryCompletePhoto.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-wrap": "wrap",
                                        gap: "4px",
                                        "margin-left": "4px",
                                      },
                                    },
                                    _vm._l(
                                      _vm.logData.deliveryCompletePhoto,
                                      function (img, idx) {
                                        return _c("el-image", {
                                          key: idx,
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            src: img.url,
                                            "preview-src-list":
                                              _vm.logData.deliveryCompletePhoto.map(
                                                function (i) {
                                                  return i.url
                                                }
                                              ),
                                            fit: "cover",
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "margin-left": "4px" } },
                                    [_vm._v("-")]
                                  ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("el-col", { attrs: { span: 8 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-item",
                              staticStyle: {
                                display: "flex",
                                "align-items": "flex-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "log-label",
                                  staticStyle: { "white-space": "nowrap" },
                                },
                                [_vm._v("送货单：")]
                              ),
                              _vm._v(" "),
                              _vm.logData.deliveryOrderPhoto &&
                              _vm.logData.deliveryOrderPhoto.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-wrap": "wrap",
                                        gap: "4px",
                                        "margin-left": "4px",
                                      },
                                    },
                                    _vm._l(
                                      _vm.logData.deliveryOrderPhoto,
                                      function (img, idx) {
                                        return _c("el-image", {
                                          key: idx,
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            src: img.url,
                                            "preview-src-list":
                                              _vm.logData.deliveryOrderPhoto.map(
                                                function (i) {
                                                  return i.url
                                                }
                                              ),
                                            fit: "cover",
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c(
                                    "span",
                                    { staticStyle: { "margin-left": "4px" } },
                                    [_vm._v("-")]
                                  ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c("div", { staticClass: "log-item" }, [
                            _c("span", { staticClass: "log-label" }, [
                              _vm._v("现场检查视频："),
                            ]),
                            _vm._v(" "),
                            _vm.logData.siteCheckVideo &&
                            _vm.logData.siteCheckVideo.length > 0
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-wrap": "wrap",
                                      gap: "8px",
                                      "margin-top": "8px",
                                    },
                                  },
                                  _vm._l(
                                    _vm.logData.siteCheckVideo,
                                    function (video, idx) {
                                      return _c("div", { key: idx }, [
                                        _c("video", {
                                          staticStyle: {
                                            width: "160px",
                                            height: "90px",
                                            "border-radius": "4px",
                                          },
                                          attrs: {
                                            src: video.url,
                                            controls: "",
                                          },
                                        }),
                                      ])
                                    }
                                  ),
                                  0
                                )
                              : _c("span", [_vm._v("-")]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.form.hasLargeFurniture === "需要安装" &&
            _vm.logData.installPhoto &&
            _vm.logData.installPhoto.length > 0
              ? _c(
                  "div",
                  { staticClass: "log-section" },
                  [
                    _c("div", { staticClass: "log-section-title" }, [
                      _vm._v("大家居安装"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "log-item",
                              staticStyle: {
                                display: "flex",
                                "align-items": "flex-start",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "log-label",
                                  staticStyle: { "white-space": "nowrap" },
                                },
                                [_vm._v("安装完成图：")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-wrap": "wrap",
                                    gap: "4px",
                                    "margin-left": "4px",
                                  },
                                },
                                _vm._l(
                                  _vm.logData.installPhoto,
                                  function (img, idx) {
                                    return _c("el-image", {
                                      key: idx,
                                      staticStyle: {
                                        width: "50px",
                                        height: "50px",
                                        "border-radius": "4px",
                                      },
                                      attrs: {
                                        src: img.url,
                                        "preview-src-list":
                                          _vm.logData.installPhoto.map(
                                            function (i) {
                                              return i.url
                                            }
                                          ),
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.sendStatus === 50 || _vm.sendStatus === 60
              ? _c(
                  "div",
                  { staticClass: "log-section" },
                  [
                    _c("div", { staticClass: "log-section-title" }, [
                      _vm._v("核算信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-table",
                      {
                        staticStyle: {
                          width: "100%",
                          "margin-top": "16px",
                          "font-size": "14px",
                        },
                        attrs: {
                          data: _vm.contractList,
                          "header-cell-style": {
                            backgroundColor: "#e8eaed",
                            color: "#333",
                            fontSize: "14px",
                          },
                          border: "",
                          "row-key": "id",
                          "show-summary": "",
                          "summary-method": _vm.getAccountingSummary,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "contractNo",
                            label: "合同号",
                            "min-width": "140",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "productionOrder",
                            label: "订单号",
                            "min-width": "160",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "solutionName",
                            label: "产品名称",
                            "min-width": "120",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "packages",
                            label: "总包数",
                            "min-width": "80",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "入库数",
                            "min-width": "80",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.inPackages != null
                                            ? scope.row.inPackages
                                            : "-"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3477781353
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "area",
                            label: "面积",
                            "min-width": "80",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "体积",
                            "min-width": "80",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.vol != null
                                            ? scope.row.vol
                                            : "-"
                                        )
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1840844585
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "送货提成",
                            "min-width": "100",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.sendStatus === 50
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                            type: "number",
                                            min: 0,
                                          },
                                          on: {
                                            change: function (v) {
                                              if (v < 0 || v === "") {
                                                scope.row.deliveryCommission =
                                                  null
                                              }
                                            },
                                          },
                                          model: {
                                            value: scope.row.deliveryCommission,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "deliveryCommission",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "scope.row.deliveryCommission",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.deliveryCommission !=
                                                null
                                                ? scope.row.deliveryCommission
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3324380094
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "大家居安装提成",
                            "min-width": "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.sendStatus === 50
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                            type: "number",
                                            min: 0,
                                          },
                                          on: {
                                            change: function (v) {
                                              if (v < 0 || v === "") {
                                                scope.row.bigHomeInstallCommission =
                                                  null
                                              }
                                            },
                                          },
                                          model: {
                                            value:
                                              scope.row
                                                .bigHomeInstallCommission,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "bigHomeInstallCommission",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "scope.row.bigHomeInstallCommission",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row
                                                .bigHomeInstallCommission !=
                                                null
                                                ? scope.row
                                                    .bigHomeInstallCommission
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1505952638
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "扛楼层数",
                            "min-width": "90",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.sendStatus === 50
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                            type: "number",
                                            min: 0,
                                          },
                                          on: {
                                            change: function (v) {
                                              if (v < 0 || v === "") {
                                                scope.row.floorCount = null
                                              }
                                            },
                                          },
                                          model: {
                                            value: scope.row.floorCount,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "floorCount",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression: "scope.row.floorCount",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.floorCount != null
                                                ? scope.row.floorCount
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3315141886
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "扛楼提成",
                            "min-width": "100",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.sendStatus === 50
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                            type: "number",
                                            min: 0,
                                          },
                                          on: {
                                            change: function (v) {
                                              if (v < 0 || v === "") {
                                                scope.row.floorCommission = null
                                              }
                                            },
                                          },
                                          model: {
                                            value: scope.row.floorCommission,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "floorCommission",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "scope.row.floorCommission",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.floorCommission != null
                                                ? scope.row.floorCommission
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4153702398
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "其它提成",
                            "min-width": "100",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.sendStatus === 50
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                            type: "number",
                                            min: 0,
                                          },
                                          on: {
                                            change: function (v) {
                                              if (v < 0 || v === "") {
                                                scope.row.otherCommission = null
                                              }
                                            },
                                          },
                                          model: {
                                            value: scope.row.otherCommission,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "otherCommission",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "scope.row.otherCommission",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.otherCommission != null
                                                ? scope.row.otherCommission
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            789148158
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "核算备注", "min-width": "140" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm.sendStatus === 50
                                      ? _c("el-input", {
                                          attrs: {
                                            placeholder: "请输入",
                                            size: "small",
                                          },
                                          model: {
                                            value: scope.row.accountingRemark,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "accountingRemark",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.accountingRemark",
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.accountingRemark != null
                                                ? scope.row.accountingRemark
                                                : "-"
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            895421483
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.sendStatus === 50
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "center",
                              "margin-top": "16px",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  loading: _vm.accountingSubmitting,
                                },
                                on: { click: _vm.handleAccountingSubmit },
                              },
                              [_vm._v("提交")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { loading: _vm.accountingSaving },
                                on: { click: _vm.handleAccountingSave },
                              },
                              [_vm._v("暂存")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }